// useAuth.js
import { useState, useEffect } from 'react';
import { getToken } from '../utils/auth'; // Ensure getToken function is correctly implemented

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('user', isAuthenticated);
    document.body.classList.toggle('guest', !isAuthenticated);
  }, [isAuthenticated])
  
  useEffect(() => {
    checkAuthenticated(); // Check authentication status on component mount
  }, []);

  const checkAuthenticated = () => {
    const token = getToken();
    if (token) {
      setIsAuthenticated(true);

    } else {
      setIsAuthenticated(false);
    }
  };

  const login = (data) => {
    localStorage.setItem('jwtToken', data.jwtToken);
    localStorage.setItem('userId', data.userName);
    localStorage.setItem('user', JSON.stringify(data));
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    checkAuthenticated, // Ensure checkAuthenticated is returned from the hook
    login,
    logout,
  };
};

export default useAuth;
